module.exports = __webpack_public_path__ + "img/adapt-menu-close.a76676fa.svg";